import {dehydrate, QueryClient} from '@tanstack/react-query';
import {GetStaticProps} from 'next';

import {Loader} from '@udemy/react-reveal-components';
import {useUDData} from '@udemy/ud-data';

import {getLayout} from 'src/components/layout';
import {PayoutReportFeature} from 'src/features/payout-report/payout-report-feature';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';

export const getStaticProps: GetStaticProps = async ({locale}) => {
    const translations = await getCompactTranslations(locale as string);
    const client = new QueryClient();

    return {
        props: {
            locale: locale,
            pageKey: 'payout-report',
            translations: translations,
            dehydratedState: dehydrate(client),
        },
        revalidate: FOUR_HOURS,
    };
};

export default function PayoutReportPage() {
    const {me} = useUDData();

    return me.is_authenticated ? (
        <PayoutReportFeature />
    ) : (
        <Loader
            size={'xxlarge'}
            style={{
                position: 'absolute',
                left: '50%',
                top: '30%',
            }}
        />
    );
    // return <PayoutReportFeature />;
}

PayoutReportPage.getLayout = getLayout;
